import React, { FC } from "react";
import { connect } from "react-redux";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import Loader from "components/Loader";
import MonoInvoice from "./MonoInvoice";
import ReceiptComponent from "containers/Receipt/ReceiptComponent";

import { ReactComponent as CloseIcon } from "assets/images/icon_delete_input.svg";

import { ApplicationState } from "store";
import { MonoQrInvoiceDto, ReceiptResponse } from "api";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

interface ReduxProps {
  receipt: ReceiptResponse | null;
  monoQrInvoice: MonoQrInvoiceDto | null;
}

interface Props {
  isOpenModal: boolean;
  receiptIsLoading: boolean;
  onCloseModal: () => void;
  onSendReceipt: () => void;
}

const ReceiptDialog: FC<Props & ReduxProps> = (props) => {
  const {
    receipt,
    monoQrInvoice,
    isOpenModal,
    receiptIsLoading,
    onCloseModal,
    onSendReceipt,
  } = props;

  const onSend = () => {
    onSendReceipt();
    analytics().sendEvent(AnalyticsEvents.sales_send_receipt_modal_btn);
  };

  return (
    <Dialog
      open={isOpenModal}
      fullWidth
      PaperProps={{ sx: { minHeight: 420, maxWidth: 424 } }}
    >
      {!receiptIsLoading && receipt ? (
        <>
          <DialogTitle>
            Чек № {receipt?.fiscalNumber || receipt?.localNumber}
            <IconButton
              aria-label="close"
              onClick={onCloseModal}
              sx={{
                position: "absolute",
                right: 8,
                top: 12,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <ReceiptComponent receipt={receipt} />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={onSend}
              size="large"
              variant="contained"
              color="inherit"
              fullWidth
            >
              Надіслати
            </Button>
            <Button
              size="large"
              variant="contained"
              onClick={onCloseModal}
              fullWidth
            >
              Закрити
            </Button>
          </DialogActions>
        </>
      ) : monoQrInvoice ? (
        <MonoInvoice onCloseModal={onCloseModal} />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          flex="1"
        >
          <Loader />
        </Box>
      )}
    </Dialog>
  );
};

const mapStateToProps = ({ receipt }: ApplicationState) => ({
  receipt: receipt.receipt,
  monoQrInvoice: receipt.monoQrInvoice,
});

export default connect(mapStateToProps, {})(ReceiptDialog);
